export default {
      // --------Transaction--------
    // transactionName: 'Transaction Name',
    // action: "Action",
    // transactionStatus: "Status",
    walletTransactions: '钱包转账',
    newWalletTransaction: '添加钱包转账',
    transactionId: "转账号",
    transactionNo: "转账编号",
    amount: "额度",
    statusConfirmationInfo: '确认状态信息',
    transactionDate: '转账日期',
    internalReferenceNo: '内部参考编号',
    internalRemark: '内部备注',

    // --------Request--------
    newWalletRequest: '添加钱包请求',
    updateWalletRequest: "更新钱包请求",
    walletRequests: '钱包请求',

    walletRequestInfo: '钱包请求信息',
    detailsOfWalletRequest: '钱包请求详细资料',
    actionType: '操作种类',
    transactionAmount: '转账额度',
    referenceNo: '参考编号',
    fromCustomer: '从客户',
    toCustomer: '至客户',
    availableWallet: '可用钱包',
    statusType: '状态种类'
};